import { render, staticRenderFns } from "./TrTable.vue?vue&type=template&id=94cc0ec6&scoped=true&"
import script from "./TrTable.vue?vue&type=script&lang=ts&"
export * from "./TrTable.vue?vue&type=script&lang=ts&"
import style0 from "./TrTable.vue?vue&type=style&index=0&id=94cc0ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cc0ec6",
  null
  
)

export default component.exports